<template>
  <div class="section">
    <div class="container">
      <div class="level">
        <Header class="level-left" v-bind="$route.meta" />
      </div>
      <div class="columns">
        <div class="column">
          <b-field grouped>
            <b-field label="Enduser">
              <multiselect
                v-model="selectedEnduser"
                :options="endusers"
                :multiple="false"
                :close-on-select="true"
                placeholder="Pick enduser"
                :custom-label="(obj) => obj.id + ' - ' + obj.name"
                track-by="name"
                style="min-width: 400px;"
              />
            </b-field>
            <b-field label="Country">
              <multiselect
                v-model="selectedCountry"
                :options="countries"
                :multiple="true"
                :close-on-select="false"
                placeholder="Pick country"
                style="min-width: 400px;"
              />
            </b-field>
          </b-field>
          <b-field>
            <b-button
              class="left-right"
              type="is-warning"
              icon-left="arrows-rotate"
              :disabled="isLoading || (selectedEnduser === null && selectedCountry === null)"
              @click="() => {resetData(); getData();}"
            >
              Load
            </b-button>
          </b-field>
          <ag-grid-vue
            v-if="closures.length != 0"
            style="width: 100%; height: 700px;"
            class="ag-theme-balham"
            :row-data="closures"
            :grid-options="gridOptions"
            :pagination="true"
            :pagination-auto-page-size="true"
            :side-bar="['columns']"
            :cache-overflow-size="0"
            :multi-sort-key="'ctrl'"
            :modules="modules"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AllModules } from '@ag-grid-enterprise/all-modules'
import { mapState } from 'vuex'
import EnduserClosure from '../../services/v2/enduserClosure'
import Enduser from '../../services/v2/enduser'
// import sortAndFilterMixins from '@/mixins/agGridSortAndFilter'

export default {
  name: 'ClosureCheck',
  components: {
  },
  data: function () {
    return {
      selectedEnduser: null,
      selectedCountry: null,
      isLoading: false,
      endusers: [],
      countries: [],
      closures: [],
      modules: AllModules,
      gridOptions: {
        cacheBlockSize: 20,
        paginationPageSize: 20,
        enableRangeSelection: true,
        defaultColDef: {
          floatingFilter: true,
          enableValue: true,
          enableRowGroup: true,
          enablePivot: false,
          resizable: true
        },
        columnDefs: [
          { headerName: 'Enduser',
            field: 'enduser',
            filter: 'agTextColumnFilter',
            width: 180,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          },
          { headerName: 'Start Date',
            field: 'startDate',
            filter: 'agTextColumnFilter',
            cellDataType: 'date',
            width: 180,
            sortable: true,
            sort: 'desc',
            filterParams: { suppressAndOrCondition: true },
            valueFormatter: (params) => {
              return params.value.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
            }
          },
          { headerName: 'End Date',
            field: 'endDate',
            filter: 'agTextColumnFilter',
            cellDataType: 'date',
            width: 180,
            sortable: true,
            filterParams: { suppressAndOrCondition: true },
            valueFormatter: (params) => {
              return params.value.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
            }
          },
          { headerName: 'Comment',
            field: 'comment',
            filter: 'agTextColumnFilter',
            width: 280,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  mounted: async function () {
    this.endusers = await Enduser.getAll()
    this.countries = [...new Set(this.endusers.map((element) => {
      return element.countryCode + ' - ' + element.country
    }))].sort()
  },
  methods: {
    resetData () {
      this.closures = []
    },
    async getData () {
      if ((!this.selectedEnduser || !this.selectedEnduser.id) && !this.selectedCountry) {
        this.$buefy.toast.open({ message: 'Please select an enduser or country', duration: 3000, type: 'is-danger' })
        return
      }
      this.isLoading = true
      try {
        var countrydata = null
        if (this.selectedCountry && this.selectedCountry.length > 0) {
          let countryEnduserCodes = []
          this.selectedCountry.forEach((country) => {
            this.endusers.filter((x) => {
              return x.countryCode === country.split(' - ')[0]
            }).forEach(element => {
              countryEnduserCodes.push(element.id)
            })
          })
          countrydata = await EnduserClosure.getCountries(countryEnduserCodes)
          countrydata.forEach((element) => {
            this.closures.push({
              enduser: this.endusers.filter((x) => {
                return x.id === element.enduserCode
              }).length > 0 ? this.endusers.filter((x) => {
                  return x.id === element.enduserCode
                })[0].name : null,
              startDate: new Date(element.startDate),
              endDate: new Date(element.endDate),
              comment: element.comment
            })
          })
        } else if (this.selectedEnduser) {
          const data = await EnduserClosure.get(this.selectedEnduser.id)
          data.forEach(element => {
            this.closures.push({
              enduser: this.selectedEnduser.name,
              startDate: new Date(element.startDate),
              endDate: new Date(element.endDate),
              comment: element.comment
            })
          })
        }
        if (this.closures.length > 0) {
          this.$buefy.toast.open({ message: 'Data loaded', duration: 3000, type: 'is-success' })
        } else {
          this.$buefy.toast.open({ message: 'No closures found', duration: 3000, type: 'is-danger' })
        }
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
        this.isLoading = false
      }
      this.isLoading = false
    }
  }
}

</script>
